import {
  getByBrandKey,
  sharedAssetUrl,
  brandAssetUrl,
  resolveBrandAssets,
} from "@coras-io/static";

const brandKey = import.meta.env.VITE_DISTRIBUTOR;
if (!brandKey) {
  throw new Error(
    "VITE_DISTRIBUTOR is not set. Build with e.g. `VITE_DISTRIBUTOR=pegasus pnpm build`.",
  );
}

const base = import.meta.env.VITE_STATIC_BASE_URL ?? "";

const entry = getByBrandKey(brandKey);

export const site = entry.site;
export const distributorId =
  import.meta.env.VITE_DISTRIBUTOR_ID || site.distributorId;

export const assetsUrl = sharedAssetUrl(base, "");
export const brand = resolveBrandAssets(entry.brand, base, brandKey);
export const brandAssetHref = (path: string): string =>
  brandAssetUrl(base, brandKey, path);
export const faviconHref = (file: string): string =>
  brandAssetHref(`assets/favicons/${file}`);
